import React, { HTMLProps } from 'react';
import classNames from 'classnames';
import Row from './Row';

const SummaryCardGroup: React.FC<HTMLProps<HTMLDivElement>> = ({ className, ...rest }) => (
  <Row className={classNames('nhsuk-card-group', className)} {...rest} />
);

export default SummaryCardGroup;